/**
 * Stylized mockup of the prioritized NIS360 action plan (task list) used as a
 * screenshot stand-in on marketing pages. Texts are intentionally hardcoded
 * German, exactly like a real product screenshot would be.
 */

const TASKS: { title: string; category: string; priority: "Sehr wichtig" | "Wichtig" }[] = [
	{
		title: "Risikoanalyse für kritische Systeme durchführen",
		category: "Risikomanagement",
		priority: "Sehr wichtig",
	},
	{
		title: "Meldewege für Sicherheitsvorfälle einrichten (24h-Frist)",
		category: "Incident Response",
		priority: "Sehr wichtig",
	},
	{
		title: "Schulungsplan für Geschäftsleitung & Mitarbeitende erstellen",
		category: "Awareness",
		priority: "Wichtig",
	},
	{
		title: "Zugriffskontrollen & MFA für kritische Konten umsetzen",
		category: "Technische Maßnahmen",
		priority: "Wichtig",
	},
];

export default function PlanMockup() {
	return (
		<div className="flex flex-col gap-3">
			<div className="flex items-center justify-between">
				<p className="font-urbanist text-[13px] font-bold text-[#1D243C]">
					Ihre priorisierten Maßnahmen
				</p>
				<span className="font-urbanist text-[10px] font-semibold text-[#2F62D9] bg-[#E2ECFF] rounded-full px-2 py-0.5">
					32 Aufgaben
				</span>
			</div>
			<div className="flex flex-col gap-2">
				{TASKS.map((task, index) => (
					<div
						key={task.title}
						className="flex items-center gap-3 bg-white border border-[#E6E6EC] rounded-lg px-3 py-2.5"
					>
						<span className="w-6 h-6 shrink-0 rounded-full bg-[#F0F4FF] text-[#2F62D9] text-[10px] font-bold flex items-center justify-center font-urbanist">
							{index + 1}
						</span>
						<div className="flex flex-col gap-0.5 min-w-0">
							<p className="font-urbanist text-[11px] font-medium text-[#1D243C] leading-[140%] truncate">
								{task.title}
							</p>
							<p className="font-urbanist text-[9px] text-[#626373]">{task.category}</p>
						</div>
						<span
							className={`ml-auto shrink-0 font-urbanist text-[9px] font-semibold px-1.5 py-0.5 rounded ${
								task.priority === "Sehr wichtig"
									? "bg-[#FFEAE0] text-[#D9580D]"
									: "bg-[#FFF6DA] text-[#A87B00]"
							}`}
						>
							{task.priority}
						</span>
					</div>
				))}
			</div>
		</div>
	);
}
